exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Nmf_W729s8f9vnXsi0oFr {\n  align-items: center;\n  display: flex;\n  flex-flow: column nowrap;\n  margin: 0px;\n}\n\n._3Nmf_W729s8f9vnXsi0oFr canvas {\n  cursor: pointer;\n}\n\n._3LKp7orSfxSqE9vZ8jHTv {\n  margin-top: -10px;\n  cursor: auto;\n  display: block;\n}\n", ""]);

// exports
exports.locals = {
	"ControlKnobContainer": "_3Nmf_W729s8f9vnXsi0oFr",
	"ControlKnobLabel": "_3LKp7orSfxSqE9vZ8jHTv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib??ref--1-1!./styles/ControlKnob.css
// module id = 205
// module chunks = 0